module.exports = __webpack_public_path__ + "fonts/pt_root-ui_medium.4a2a3e5.ttf";